import { removeLocalStorageValue } from 'technical/local-storage';
import {
  LAST_SYNC_TIMESTAMP_KEY,
  PENDING_UPLOAD_TIMESTAMP_KEY,
  SCAN_PATTERN_KEY,
  SCAN_SITE_KEY,
  SEGMENT_TYPES_KEY,
} from 'technical/local-storage/constants';

export const appLocalDataService = {
  delete: async () => {
    removeLocalStorageValue({ key: SCAN_SITE_KEY });
    removeLocalStorageValue({ key: SEGMENT_TYPES_KEY });
    removeLocalStorageValue({ key: SCAN_PATTERN_KEY });
    removeLocalStorageValue({ key: LAST_SYNC_TIMESTAMP_KEY });
    removeLocalStorageValue({ key: PENDING_UPLOAD_TIMESTAMP_KEY });
  },
};
